/**
 * Structured logging for API failures (axios error path only).
 * Dev: console with message, requestId, URL.
 * Prod: quiet by default; extend `setApiFailureLogHook` if you wire APM later.
 */

let customHook = null;

export function setApiFailureLogHook(fn) {
  customHook = typeof fn === 'function' ? fn : null;
}

/**
 * @param {object} ctx
 * @param {import('./restApiError').ApiClientError} ctx.apiClientError
 * @param {import('axios').AxiosError} [ctx.axiosError]
 */
export function reportApiFailure({ apiClientError, axiosError }) {
  if (customHook) {
    try {
      customHook({ apiClientError, axiosError });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('reportApiFailure hook failed', e);
    }
    return;
  }

  if (process.env.NODE_ENV !== 'development') {
    return;
  }

  // eslint-disable-next-line no-console
  console.error('[API failure]', {
    message: apiClientError?.message,
    requestId: apiClientError?.requestId,
    url: apiClientError?.url,
    httpStatus: apiClientError?.httpStatus,
    apiStatusCode: apiClientError?.apiStatusCode,
  });
}
